import {Routes} from '@angular/router';
import {
  goodsDetailImgManagementRoutes
} from "./goods-detail-img-management/goods-detail-img-management.routes";
import {
  goodsDetailPropertyManagementRoutes
} from "./goods-detail-property-management/goods-detail-property-management.routes";

export const serviceManagementRoutes: Routes = [
  {
    path: 'serviceGoodsManagement',
    loadComponent: () => import('./service-goods-management/service-goods-management.component').then(m => m.ServiceGoodsManagementComponent),
    data: {title: '服务项目管理'},
  },
  {
    path: 'serviceBrandManagement',
    loadComponent: () => import('./service-brand-management/service-brand-management.component').then(m => m.ServiceBrandManagementComponent),
    data: {title: '服务项目品牌管理'},
  },
  {
    path: 'serviceCategoryManagement',
    loadComponent: () => import('./service-category-management/service-category-management.component').then(m => m.ServiceCategoryManagementComponent),
    data: {title: '服务项目品类管理'},
  },
  {
    path: 'addServiceGoods',
    loadComponent: () => import('./service-goods-management/add-service-goods/add-service-goods.component').then(m => m.AddServiceGoodsComponent),
    data: {title: '添加服务项目'},
  },
  {
    path: 'addServiceGoods/:goodsId',
    loadComponent: () => import('./service-goods-management/add-service-goods/add-service-goods.component').then(m => m.AddServiceGoodsComponent),
    data: {title: '编辑服务项目'},
  },
  {
    path: 'serviceUnitManagement',
    loadComponent: () => import('./service-unit-management/service-unit-management.component').then(m => m.ServiceUnitManagementComponent),
    data: {title: '服务项目计量单位管理'},
  },
  {
    path: 'serviceSkuManagement',
    loadComponent: () => import('./service-sku-management/service-sku-management.component').then(m => m.ServiceSkuManagementComponent),
    data: {title: '服务项目SKU管理'},
  },
  {
    path: 'addServiceSku',
    loadComponent: () => import('./service-sku-management/add-service-sku/add-service-sku.component').then(m => m.AddServiceSkuComponent),
    data: {title: '添加服务项目SKU'},
  },
  {
    path: 'addServiceSku/:goodsId',
    loadComponent: () => import('./service-sku-management/add-service-sku/add-service-sku.component').then(m => m.AddServiceSkuComponent),
    data: {title: '编辑服务项目SKU'},
  },
  {
    path: 'serviceCategoryManagement',
    loadComponent: () => import('./service-category-management/service-category-management.component').then(m => m.ServiceCategoryManagementComponent),
    data: {title: '品类管理'},
  },
  {
    path: 'serviceGoodsCodeManagement',
    loadComponent: () => import('./service-goodscode-management/service-goodscode-management.component').then(m => m.ServiceGoodscodeManagementComponent),
    data: {title: '商品编码管理'},
  },
  ...goodsDetailImgManagementRoutes,
  ...goodsDetailPropertyManagementRoutes,
];
